module.exports = __webpack_public_path__ + "img/冲床装配图.SLDASM.e1d43a0f.jpg";